import { Component } from '@angular/core';
import { AuthService } from 'src/app/facade/auth/auth.service';
import { Router } from '@angular/router';

@Component({
	selector: 'app-login-parent',
	templateUrl: './login-parent.component.html',
	styleUrls: ['./login-parent.component.scss']
})
export class LoginParentComponent {
	requesting;
	serverError;

	constructor(private authService: AuthService, private router: Router) {
		if (this.authService.currentUserValue) {
			this.router.navigate(['/scenario-one']);
		}
	}

	handleLoginForm(loginFormValue) {
		this.tokenAuth(loginFormValue);
	}

	tokenAuth(formData) {
		this.requesting = true;
		this.authService.login(formData).subscribe(
			result => {
				if (result['data'] && result['data']['tokenAuth'].token) {
					window.localStorage.setItem(
						'token',
						result['data']['tokenAuth'].token
					);

					this.getCurrentUser();
					this.requesting = false;
				}
			},
			error => {
				this.requesting = false;
				console.log(error);

				this.serverError = 'Email addresa ose fjalëkalimi janë gabim!';
			}
		);
	}

	getCurrentUser() {
		this.authService.getCurrentUser();
	}
}
